import { Box, NavLink, Stack, Text, ThemeIcon } from "@mantine/core";
import { TbChevronRight } from "react-icons/tb";

import SideMenuLink from "../SideMenuLink";

import { checkActiveLink } from "modules/core/utils/helpers";

import classes from "./styles.module.css";

type SideMenuGroupProps = {
  label: string;
  defaultOpened?: boolean;
  links: Array<{
    label: string;
    icon: React.ReactNode;
    url: string;
    activeRegex?: RegExp;
  }>;
};

const SideMenuGroup = (props: SideMenuGroupProps) => {
  const { label, defaultOpened, links } = props;

  const isActive = links.some(link =>
    checkActiveLink(link.url, link.activeRegex)
  );

  return (
    <Box ml="md">
      <NavLink
        defaultOpened={defaultOpened || isActive}
        href="#"
        m={0}
        variant="subtle"
        styles={{
          children: {
            paddingInlineStart: 0,
            margin: "10px 0 10px 10px",
            padding: 0,
            borderLeft: "1px solid #333"
          }
        }}
        label={
          <Text fz="xs" c="gray.2" fw={500} tt="capitalize">
            {label}
          </Text>
        }
        p={0}
        rightSection={
          <ThemeIcon size="xs" color="gray.5">
            <TbChevronRight />
          </ThemeIcon>
        }
        className={classes.link}
      >
        <Stack gap={2}>
          {links.map(link => (
            <SideMenuLink key={link.url} isChild {...link} />
          ))}
        </Stack>
      </NavLink>
    </Box>
  );
};

export default SideMenuGroup;
